import React from "react";
import PropTypes from 'prop-types';
import DefaultType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import ScriptType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType/ScriptType";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import SelectType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import OnClosePopupActions from "./OnClosePopupActions";
import TextType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/TextType";

const AdditionalTypeFields = ({
                                  type,
                                  setValue,
                                  actions,
                                  path,
                                  listStorage,
                                  entities,
                                  selectedComponent,
                                  contextList
                              }) => {
    switch (type) {
        case 'nextScreen':
            return <NextScreen setValue={setValue} actions={actions} path={path}/>;
        case 'readRecord':
            return (
                <>
                    <EntityList
                        setValue={setValue}
                        actions={actions}
                        path={path}
                        entities={entities}
                    />
                    <StringField setValue={setValue} actions={actions} path={path} label={'Record Id'} name={'value'}/>
                </>
            );
        case 'sendRequest':
            return (
                <>
                    <Url setValue={setValue} actions={actions} path={path}/>
                    <SetToVar setValue={setValue} actions={actions} path={path}/>
                </>
            );
        case 'openPopup':
            return (
                <>
                    <NextScreen setValue={setValue} actions={actions} path={path}/>
                    <ReturnPath setValue={setValue} actions={actions} path={path}/>
                    <OnClosePopupActions
                        values={actions}
                        setValue={setValue}
                        path={path}
                    />
                    <div>
                        <StringField setValue={setValue} actions={actions} path={path} label={'Popup Width'}
                                     name={'width'}/>
                        <StringField setValue={setValue} actions={actions} path={path} label={'Popup Height'}
                                     name={'height'}/>
                    </div>
                </>
            );
        case 'openDrawer':
            return (
                <>
                    <NextScreen setValue={setValue} actions={actions} path={path}/>
                    <ReturnPath setValue={setValue} actions={actions} path={path}/>
                    <OnClosePopupActions
                        values={actions}
                        setValue={setValue}
                        path={path}
                    />
                    <div>
                        <StringField setValue={setValue} actions={actions} path={path} label={'Drawer Width'} name={'width'}/>
                        <StringField setValue={setValue} actions={actions} path={path} label={'Drawer Height'} name={'height'}/>
                    </div>
                </>
            )
        case 'setVariable':
            return <VariableName setValue={setValue} actions={actions} path={path}/>;
        case 'setFilter':
            return (<>
                <ListId
                    setValue={setValue}
                    actions={actions}
                    path={path}
                    listStorage={listStorage}
                    selectedComponent={selectedComponent}
                />
                <SelectType
                    labelStyles={{width: 100}}
                    fieldStyles={{width: 200}}
                    values={actions}
                    field={{
                        label: 'Force on load filter',
                        path: `${path}.forceOnLoadFilter`,
                        type: 'bool',
                    }}
                    setValue={setValue}
                />
                <StringField setValue={setValue} actions={actions} path={path} label={'Filter Source'} name={'filterSource'}/>
                <SelectType
                    labelStyles={{width: 100}}
                    fieldStyles={{width: 200}}
                    values={actions}
                    field={{
                        label: 'Persistent',
                        path: `${path}.persistent`,
                        type: 'bool',
                    }}
                    setValue={setValue}
                />
                <SelectType
                    labelStyles={{width: 100}}
                    fieldStyles={{width: 200}}
                    values={actions}
                    field={{
                        label: 'Merge Filter',
                        path: `${path}.merge`,
                        type: 'bool',
                    }}
                    setValue={setValue}
                />
            </>);
        case 'setListData':
            return selectedComponent.component.type !== 'list' && (
                <ListId setValue={setValue} actions={actions} path={path} listStorage={listStorage}/>);
        case 'getListData':
            return <>
                <ListsList setValue={setValue} actions={actions} path={path}/>
                <VariableName setValue={setValue} actions={actions} path={path}/>
            </>
        case 'getData':
            return <TrackVariable setValue={setValue} actions={actions} path={path}/>;
        case 'message':
            return (
                <MessageSetup setValue={setValue} actions={actions} path={path}/>
            );
        case 'confirmCloseScreen':
            return (
                <MessageSetup setValue={setValue} actions={actions} path={path}/>
            );
        case 'downloadFile':
            return (
                <>
                    <Url setValue={setValue} actions={actions} path={path}/>
                    <SetToVar setValue={setValue} actions={actions} path={path}/>
                </>
            );
        case 'uploadAvatar':
            return(
                <>
                    <SetToVar setValue={setValue} actions={actions} path={path}/>
                </>
            )
        case 'uploadFile':
            return (
                <>
                    <SetToVar setValue={setValue} actions={actions} path={path}/>
                    <FileMask setValue={setValue} actions={actions} path={path}/>
                    <NumberField setValue={setValue} actions={actions} path={path} label={'Max Size (mb)'}
                                 name={'maxSize'}/>
                    <StringField setValue={setValue} actions={actions} path={path} label={'Input Id'} name={'inputId'}/>
                    <StringField setValue={setValue} actions={actions} path={path} label={'File Type'}
                                 name={'fileType'}/>
                    <StringField setValue={setValue} actions={actions} path={path} label={'Ref Entity'}
                                 name={'refEntity'}/>
                    <StringField setValue={setValue} actions={actions} path={path} label={'Ref Id'} name={'refId'}/>
                    <StringField setValue={setValue} actions={actions} path={path} label={'Shared With'}
                                 name={'sharedWith'}/>
                </>
            );
        case 'refreshData':
            return <ListId setValue={setValue} actions={actions} path={path} listStorage={listStorage}/>;
        case 'createEntity':
            return <EntityList
                setValue={setValue}
                actions={actions}
                path={path}
                entities={entities}
            />;
        case 'updateEntity':
            return <EntityList
                setValue={setValue}
                actions={actions}
                path={path}
                entities={entities}
            />;
        case 'deleteEntity':
            return <EntityList
                setValue={setValue}
                actions={actions}
                path={path}
                entities={entities}
            />;
        case 'startProcess':
            return (
                <>
                    <BpmnList
                        setValue={setValue}
                        actions={actions}
                        path={path}
                    />
                    <SelectType
                        labelStyles={{width: 100}}
                        fieldStyles={{width: 200}}
                        values={actions}
                        field={{
                            label: 'Ignore BPMN Actions',
                            path: `${path}.ignoreActions`,
                            type: 'bool',
                        }}
                        setValue={setValue}
                    />
                </>)
        case 'startTask':
            return <>
                <TaskId
                    setValue={setValue}
                    actions={actions}
                    path={path}
                />
                <SetToVar
                    setValue={setValue}
                    actions={actions}
                    path={path}
                />
                <SelectType
                    labelStyles={{width: 100}}
                    fieldStyles={{width: 200}}
                    values={actions}
                    field={{
                        label: 'Ignore BPMN Actions',
                        path: `${path}.ignoreActions`,
                        type: 'bool',
                    }}
                    setValue={setValue}
                />
            </>;
        case 'completeTask':
            return <>
                <TaskId
                    setValue={setValue}
                    actions={actions}
                    path={path}
                />
                <SetToVar
                    setValue={setValue}
                    actions={actions}
                    path={path}
                />
                <SelectType
                    labelStyles={{width: 100}}
                    fieldStyles={{width: 200}}
                    values={actions}
                    field={{
                        label: 'Ignore BPMN Actions',
                        path: `${path}.ignoreActions`,
                        type: 'bool',
                    }}
                    setValue={setValue}
                />
            </>;
        case 'deleteTask':
            return (
                <>
                    <TaskId
                        setValue={setValue}
                        actions={actions}
                        path={path}
                    />
                    <SelectType
                        labelStyles={{width: 100}}
                        fieldStyles={{width: 200}}
                        values={actions}
                        field={{
                            label: 'Ignore BPMN Actions',
                            path: `${path}.ignoreActions`,
                            type: 'bool',
                        }}
                        setValue={setValue}
                    />
                </>);
        case 'executeJs':
            return <ExecuteJS
                setValue={setValue}
                actions={actions}
                path={path}
            />;
        case 'setStyles':
            return <ExecuteJS
                setValue={setValue}
                actions={actions}
                path={path}
            />;
        case 'openContext':
            return <ContextList setValue={setValue} actions={actions} path={path} contextList={contextList}/>;
        case 'cancel':
            return <SelectType
                labelStyles={{width: 100}}
                fieldStyles={{width: 200}}
                values={actions}
                field={{
                    label: 'Show Confirmation',
                    path: `${path}.showConfirm`,
                    type: 'bool',
                }}
                setValue={setValue}
            />
        case 'externalLink':
            return (
                <>
                    <DefaultType
                        labelStyles={{width: 100}}
                        values={actions}
                        field={{
                            label: 'Url',
                            path: `${path}.destination`,
                        }}
                        setValue={setValue}
                    />
                    <DefaultType
                        labelStyles={{width: 100}}
                        values={actions}
                        field={{
                            label: 'Mode',
                            type: 'objSelect',
                            path: `${path}.mode`,
                            values: [
                                {value: '_blank', label: 'New tab'},
                                {value: '_parent', label: 'Current Tab'},
                            ]
                        }}
                        setValue={setValue}
                    />
                </>
            )
        case 'scrollToBlock':
            return (
                <>
                    <DefaultType
                        labelStyles={{width: 100}}
                        values={actions}
                        field={{
                            label: 'Container Id',
                            path: `${path}.value`,
                        }}
                        setValue={setValue}
                    />
                    <DefaultType
                        labelStyles={{width: 100}}
                        values={actions}
                        field={{
                            label: 'Block Id',
                            path: `${path}.destination`,
                        }}
                        setValue={setValue}
                    />
                </>
            )
        case 'cameraScreenshot':
            return <VariableName setValue={setValue} actions={actions} path={path}/>;
        default:
            return <></>
    }
};
export default AdditionalTypeFields;

AdditionalTypeFields.propTypes = {
    type: PropTypes.string,
    setValue: PropTypes.func,
    actions: PropTypes.array,
    path: PropTypes.string,
    listStorage: PropTypes.array
};


const Url = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Url',
                path: `${path}.destination`,
            }}
            setValue={setValue}
        />
    )
};
const ReturnPath = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Return Path',
                path: `${path}.returnPath`,
            }}
            setValue={setValue}
        />
    )
};
const NextScreen = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Screen ID',
                path: `${path}.destination`,
                dropdown: 'screenDropdownList'
            }}
            setValue={setValue}
        />
    )
};
const SetToVar = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Set To Var',
                path: `${path}.setToVar`,
            }}
            setValue={setValue}
        />
    )
};
const TrackVariable = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Track Variable',
                path: `${path}.trackVariable`,
            }}
            setValue={setValue}
        />
    )
};
const VariableName = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Variable Name',
                path: `${path}.destination`,
            }}
            setValue={setValue}
        />
    )
};
const FileMask = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                isArray: true,
                label: 'File Mask',
                path: `${path}.fileMask`,
            }}
            setValue={setValue}
        />
    )
};
const ListId = ({actions, setValue, path, listStorage}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'List Id',
                path: `${path}.destination`,
                type: 'objSelect',
                values: listStorage.map(l => {
                    return {label: l, value: l}
                })

            }}
            setValue={setValue}
        />
    )
};
const EntityList = ({actions, setValue, path, entities = []}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Entity',
                path: `${path}.destination`,
                type: 'objSelect',
                values: entities.map(l => {
                    return {label: l, value: l}
                })

            }}
            setValue={setValue}
        />
    )
};
const BpmnList = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Process Id',
                path: `${path}.processId`,
                type: 'string',
                dropdown: 'bpmnDropdownList'
            }}
            setValue={setValue}
        />
    )
};
const ListsList = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'List Id',
                path: `${path}.listId`,
                type: 'string',
                dropdown: 'listDropdownList'
            }}
            setValue={setValue}
        />
    )
}
const TaskId = ({actions, setValue, path}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            fieldStyles={{width: 196}}
            field={{
                label: 'Task Id',
                path: `${path}.taskId`,
            }}
            setValue={setValue}
        />
    )
};
const ExecuteJS = ({actions, setValue, path}) => {
    return (
        <ScriptType
            labelStyles={{width: 100}}
            fieldStyles={{width: '100%', fullWidth: true}}
            values={actions}
            field={{
                label: 'Java Script',
                inputMode: 'inline',
                path: `${path}.value`,
                syntaxHighlight: "javascript"
            }}
            setValue={setValue}
        />
    )
};
const ContextList = ({actions, setValue, path, contextList}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label: 'Context',
                path: `${path}.destination`,
                type: 'objSelect',
                values: contextList.map(i => {
                    return {
                        label: i.properties ? i.properties.context : 'Context',
                        value: i.properties ? i.properties.context : 'context'
                    }
                })

            }}
            setValue={setValue}
        />
    )
};


const StringField = ({actions, setValue, path, name, label}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                label,
                path: `${path}.${name}`,
            }}
            setValue={setValue}
        />
    )
};
const NumberField = ({actions, setValue, path, name, label}) => {
    return (
        <DefaultType
            labelStyles={{width: 100}}
            values={actions}
            field={{
                type: 'number',
                label,
                path: `${path}.${name}`,
            }}
            setValue={setValue}
        />
    )
};

const MessageSetup = ({path, actions, setValue}) => {
    const isPopup = findByString(actions, `${path}.isPopup`);

    return (
        <div>
            <DefaultType
                labelStyles={{width: 100}}
                fieldStyles={{width: 200}}
                values={actions}
                field={{
                    label: 'Message Type',
                    path: `${path}.msgType`,
                    type: 'objSelect',
                    values: [
                        {value: 'success', label: "Success"},
                        {value: "warning", label: "Warning"},
                        {value: "error", label: "Error"},
                        {value: "info", label: "Info"}
                    ]
                }}
                setValue={setValue}
            />
            <SelectType
                labelStyles={{width: 100}}
                fieldStyles={{width: 200}}
                values={actions}
                field={{
                    label: 'Popup View',
                    path: `${path}.isPopup`,
                    type: 'bool',
                }}
                setValue={setValue}
            />
            {isPopup && (
                <>
                <DefaultType
                    labelStyles={{width: 100}}
                    fieldStyles={{width: 200}}
                    values={actions}
                    field={{
                        label: 'Title',
                        path: `${path}.title`,
                        type: 'string',
                        multiLanguage: true
                    }}
                    setValue={setValue}
                />
                    <SelectType
                        labelStyles={{width: 100}}
                        fieldStyles={{width: 200}}
                        values={actions}
                        field={{
                            label: 'Max Width',
                            path: `${path}.width`,
                            type: 'objSelect',
                            values: [
                                {value: 'xs', label: 'XS'},
                                {value: 'sm', label: 'SM'},
                                {value: 'md', label: 'MD'},
                                {value: 'xl', label: 'XL'}
                            ]
                        }}
                        setValue={setValue}
                    />
                </>
            )}
            <TextType
                labelStyles={{width: 100}}
                fieldStyles={{width: 200}}
                values={actions}
                field={{
                    label: 'Message',
                    path: `${path}.value`,
                    multiLanguage: true,
                }}
                setValue={setValue}
            />
            {isPopup && (
                <>
                    <DefaultType
                        labelStyles={{width: 100}}
                        fieldStyles={{width: 200}}
                        values={actions}
                        field={{
                            label: 'Buttons',
                            path: `${path}.buttons`,
                            type: 'string',
                            isArray: true,
                            multiLanguage: true
                        }}
                        setValue={setValue}
                    />
                </>
            )}
        </div>
    )
};